/**
 * `components.MuiToggleButton` & `MuiToggleButtonGroup` — text transform and grouped button spacing/borders.
 * Discoverability: `MuiToggleButton`, `ToggleButton`, `ToggleButtonGroup`.
 *
 * @see https://mui.com/material-ui/api/toggle-button/
 * @see https://mui.com/material-ui/api/toggle-button-group/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiToggle(_theme: Theme): Pick<Components<Theme>, 'MuiToggleButton' | 'MuiToggleButtonGroup'> {
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        firstButton: {
          borderStyle: 'hidden',
          borderRadius: 'inherit',
          margin: 2,
        },
        middleButton: {
          borderStyle: 'hidden',
          borderRadius: 'inherit',
          margin: 2,
        },
        lastButton: {
          borderStyle: 'hidden',
          borderRadius: 'inherit',
          margin: 2,
        },
      },
    },
  };
}
